import http from "../http-common";
import {
  IMongerlabCustomer,
  IMongerlabCustomerLookup,
  IMongerlabCustomerNote,
  IMongerlabCustomerPaginatedResponse,
  IMongerlabCustomerStatusLog,
} from "../types/MongerlabCustomer";

const getAll = (filterCriteria: string = "") => {
  return http.get<IMongerlabCustomerPaginatedResponse>(`/mongerlab-customers${filterCriteria}`);
};

const getById = (id: number) => {
  return http.get<IMongerlabCustomer>(`/mongerlab-customers/${id}`);
};

const getCrmStatuses = () => {
  return http.get<IMongerlabCustomerLookup[]>(`/mongerlab-customer-statuses`);
};

const getRoles = () => {
  return http.get<IMongerlabCustomerLookup[]>(`/mongerlab-customer-roles`);
};

const getAppStatuses = () => {
  return http.get<IMongerlabCustomerLookup[]>(`/mongerlab-customer-app-statuses`);
};

const updateCrmStatus = (id: number, data: { crmStatusId: number }) => {
  return http.patch<IMongerlabCustomer>(`/mongerlab-customers/${id}/crm-status`, data);
};

const getStatusLogs = (id: number) => {
  return http.get<IMongerlabCustomerStatusLog[]>(`/mongerlab-customers/${id}/status-logs`);
};

const getNotes = (id: number) => {
  return http.get<IMongerlabCustomerNote[]>(`/mongerlab-customers/${id}/notes`);
};

const createNote = (id: number, data: { description: string }) => {
  return http.post<IMongerlabCustomerNote>(`/mongerlab-customers/${id}/notes`, data);
};

const deleteNote = (noteId: number) => {
  return http.delete(`/mongerlab-customers/notes/${noteId}`);
};

const createCrmStatus = (data: { name: string }) => {
  return http.post<IMongerlabCustomerLookup>(`/mongerlab-customer-statuses`, data);
};

const updateCrmStatusLookup = (id: number, data: { name?: string; active?: boolean }) => {
  return http.put<IMongerlabCustomerLookup>(`/mongerlab-customer-statuses/${id}`, data);
};

const updateRole = (id: number, data: { name?: string; active?: boolean }) => {
  return http.put<IMongerlabCustomerLookup>(`/mongerlab-customer-roles/${id}`, data);
};

const updateAppStatus = (id: number, data: { name?: string; active?: boolean }) => {
  return http.put<IMongerlabCustomerLookup>(`/mongerlab-customer-app-statuses/${id}`, data);
};

const MongerlabCustomerService = {
  getAll,
  getById,
  getCrmStatuses,
  getRoles,
  getAppStatuses,
  updateCrmStatus,
  getStatusLogs,
  getNotes,
  createNote,
  deleteNote,
  createCrmStatus,
  updateCrmStatusLookup,
  updateRole,
  updateAppStatus,
};

export default MongerlabCustomerService;
